'use strict';

module.exports = 4294967295;
